<template>
  <div>
    <skeleton-rate v-if="loading"></skeleton-rate>
    <div v-else>
        <ContentHeader title="Rate" />
        <section class="content">
        <div class="container-fluid pl-3">
            <router-link :to="{ name: 'UpdateRate' }" class="btn btn-outline-danger badge-pill pr-3 pl-3">
                Change rate
            </router-link>
        </div>
        <div class="container-fluid mt-3 mt-md-1">
            <div class="row">
                <div class="col-12 col-md-6 p-1 p-md-3">
                    <div class="card p-3" style="margin-bottom:0.1rem; !important">
                        <h4>Manager Cabang</h4>
                            <h1 style="text-align: right; font-size:4rem; font-weight:600;" class="float-right p-1 mr-4 mr-xl-5">{{parseInt(datarate.CORPORATE_PARTNER*100)}}%</h1>
                    </div>
                </div>
                <div class="col-12 col-md-6 p-1 p-md-3">
                    <div class="card p-3" style="margin-bottom:0.1rem; !important">
                        <h4>Agent Level</h4>
                            <h1 style="text-align: right; font-size:4rem; font-weight:600;" class="float-right p-1 mr-4 mr-xl-5">{{parseInt(datarate.INTRODUCING_BROKER*100)}}%</h1>
                    </div>
                </div>
                <div class="col-12 col-md-6 p-1 p-md-3">
                    <div class="card p-3" style="margin-bottom:0.1rem; !important">
                        <h4>Supervisor Area</h4>
                        <!-- <h4>Partner IB</h4> -->
                            <h1 style="text-align: right; font-size:4rem; font-weight:600;" class="float-right p-1 mr-4 mr-xl-5">{{parseInt(datarate.PARTNER_IB*100)}}%</h1>
                    </div>
                </div>
                <div class="col-12 col-md-6 p-1 p-md-3">
                    <div class="card p-3" style="margin-bottom:0.1rem; !important">
                        <h4>Manager Area</h4>
                        <!-- <h4>Master IB</h4> -->
                            <h1 style="text-align: right; font-size:4rem; font-weight:600;" class="float-right p-1 mr-4 mr-xl-5">{{parseInt(datarate.MASTER_IB*100)}}%</h1>
                    </div>
                </div>
            </div>
        </div>
        </section>
    </div>
  </div>
</template>

<style>
@import "../../../public/custom_styles/profile.css";
</style>

<script>
import SkeletonRate from "../../components/loading-screen/RateSkeleton.vue"
import ContentHeader from "@/components/molecules/ContentHeader.vue";
import apiClient from '../../services/ApiServices';
export default {
  components: {
    ContentHeader,
    SkeletonRate
  },
  
  data() {
    return {
      loading: true,
        datarate:[]
    };
  },
  async mounted() {
    try {
      let response = await apiClient.get(`${this.$user_id}/disbursement/settings/rate/`)
      this.datarate = response.data.data
      console.log(this.datarate)
    } catch (error) {
      this.$swal(
        "Oooopss....",
        error.data.data.message,
        "error"
      );
    } finally {
      this.loading = false
    }
  },
};
</script>
